export default "/_next/static/images/charts@2x-26b6b481f1ca8d106537de714af2c575.png";